import { configureStore } from "@reduxjs/toolkit"

import { breadcrumbSlice } from "@/utils/store/breadcrumb"
import { gatewaySlice } from "@/utils/store/gateway"
import { notificationsSlice } from "@/utils/store/notification"
import { organizationSlice } from "@/utils/store/organization"
import { siteSlice } from "@/utils/store/site"

export default configureStore({
  reducer: {
    notifications: notificationsSlice.reducer,
    breadcrumb: breadcrumbSlice.reducer,
    site: siteSlice.reducer,
    organization: organizationSlice.reducer,
    gateway: gatewaySlice.reducer
  }
})
